let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bl1Ah")).then(() => parcelRequire('1wUM2'));